import { RootState } from "../types";

export const callStateSelector = (state: RootState) => state.callCenter.callState;

export const currentCallSelector = (state: RootState) => state.callCenter.currentCall;

export const cdrDataSelector = (state: RootState) => state.callCenter.cdrData;

export const isRecordingSelector = (state: RootState) => state.callCenter.isRecording;

export const recordingPausedSelector = (state: RootState) => state.callCenter.recordingPaused;

export const callDurationSelector = (state: RootState) => state.callCenter.callDuration;

export const newUserFormSelector = (state: RootState) => state.callCenter.newUserForm;

export const isCallActiveSelector = (state: RootState) => 
  state.callCenter.callState === "active";

export const isCallRingingSelector = (state: RootState) => 
  state.callCenter.callState === "ringing";

export const isCallEndedSelector = (state: RootState) => 
  state.callCenter.callState === "ended";
